<template>
  <div class="mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-12 banner-title">
            <i class="material-icons md-36" @click="goBack">keyboard_arrow_left</i>
            <span class="title-text" @click="goBack">{{ $t('message.register') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-9 bg-white py-4">
        <form class="pt-2 pb-4 d-flex flex-wrap justify-content-center" @submit.prevent="register">
          <h3
            class="w-75 mb-5 mt-4 d-flex justify-content-center"
          >{{ $t('message.createYourAccount') }}</h3>
          <div class="form-group w-75">
            <label for="First Name">{{ $t('message.firstName') }}</label>
            <input
              v-validate="'required'"
              id="FirstName"
              v-model="firstName"
              name="First Name"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">{{ OOErrors.first("First Name") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="Last Name">{{ $t('message.lastName') }}</label>
            <input
              v-validate="'required'"
              id="LastName"
              v-model="lastName"
              name="Last Name"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">{{ OOErrors.first("Last Name") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="email">{{ $t('message.emailAddress') }}</label>
            <input
              id="EmailId"
              v-model="email"
              v-validate="'required|email'"
              type="email"
              name="email"
              class="form-control"
              aria-describedby="emailHelp"
            />
            <div class="invalid-feedback">{{ OOErrors.first("email") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="password">{{ $t('message.password') }}</label>
            <input
              id="passwordId"
              v-model="password"
              type="password"
              name="password"
              v-validate="'required'"
              class="form-control"
              ref="password"
            />
            <div class="invalid-feedback">{{ OOErrors.first("password") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="Confirm Password">{{ $t('message.confirmPassword') }}</label>
            <input
              id="ConfirmPasswordId"
              v-model="confirmPassword"
              type="password"
              name="Confirm Password"
              v-validate="'required|confirmed:password'"
              class="form-control"
            />
            <div class="invalid-feedback">{{ OOErrors.first("Confirm Password") }}</div>
          </div>

          <div class="w-75 mt-4 justify-content-center">
            <p
              v-html="$t('message.termsOfUsePrivacyStatement')"
              style="font-size:0.6875rem;line-height: 1.4;text-align: center;"
            ></p>
          </div>

          <div class="w-75 mt-3">
            <button
              :disabled="loading"
              :style="mobileStyles.btn"
              type="submit"
              class="btn btn-lg btn-sign-in btn-block shadow btn-primary d-flex justify-content-center align-items-center fs-1 fw-600"
            >
              {{ $t('message.register') }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>

          <div class="w-75 mt-4 d-flex justify-content-center">
            {{ $t('message.alreadyHaveProfile') }}?&nbsp;
            <a
              href="#"
              :style="mobileStyles.LinkColorTxt"
              @click="gotoLogin()"
            >{{ $t('message.signIn') }}</a>
          </div>
          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
          <div v-if="FacebookLogin || GoogleLogin" class="w-75 my-4 d-flex justify-content-center">
            <strong>or</strong>
          </div>
          <div class="container">
            <div class="row mb-4 justify-content-center">
              <auth-providers-login />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../../sharedscripts/user/register.js";
import AuthProvidersLogin from "./AuthProvidersLogin";
import { mapGetters } from "vuex";
export default {
  components: {
    AuthProvidersLogin
  },
  props: {
    storeid: {
      type: String,
      default: null
    },
    forgift: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      loading: false,
      error: "",
      returnComponent: "store"
    };
  },
  beforeRouteEnter(to, from, next) {
    var fromName = from.name;
    next(vm => {
      if (fromName && fromName != "login") vm.$data.returnComponent = fromName;
    });
  },
  mounted() {
    this.setStoreLoaded();
  },
  computed: {
    ...mapGetters(["currentStoreDoc", "mobileStyles", "viewConfig"]),
    FacebookLogin() {
      return this.viewConfig.FacebookLogin;
    },
    GoogleLogin() {
      return this.viewConfig.GoogleLogin;
    }
  },
  methods: {
    ...shared.methods,
    goBack() {
      this.$router.push({
        name: this.returnComponent,
        params: {
          storeid: this.currentStoreDoc.ID,
          storename: this.currentStoreDoc.Name
        }
      });
    },
    gotoLogin() {
      this.$router.push({
        name: "login"
      });
    }
  }
};
</script>
